import React, { useEffect, useState } from "react";
import style from "./index.module.scss";

import { Breadcrumb, Table, Tabs, Empty, Form, Rate, Checkbox, Input, Button, message, Tooltip, Space } from "antd";
import cs from "classnames";
import "@jdcfe/legao/dist/@jdcfe/legao.css";

import upIcon from "./up_icon.png";
import downIcon from "./down_icon.png";
import tagIcon from "./icon_inline.png";
import iconQuestion from "./icon_question.png";
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
let _host = "";
let _loginHost = "";

const getUrlParam = (paraName: string) => {
  const url = document.location.toString();
  const arrObj = url.split("?");

  if (arrObj.length > 1) {
    const arrPara = arrObj[1].split("&");
    let arr;

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
};

export interface IAppProps {
  apiHost: string;
  proposalList: object[];
  moreProposalPlaceholder: string;
  loginHost: string;
}

/**
 * 链接跳转
 * params: params
 * 备注：自动识别link中是否自带请求参数，避免参数覆盖或丢失
 *
 */
const jumpLink = (paramStr: any) => {
  const link = window.location.href;
  if (link.indexOf("?")) {
    window.location.href = `${link.split("?")[0]}?${paramStr}`;
  } else {
    window.location.href = `${link}?${paramStr}`;
  }
};

const App: React.SFC<IAppProps> = (props) => {
  const { apiHost, proposalList, moreProposalPlaceholder, loginHost } = props;
  _host = apiHost;
  _loginHost = loginHost;
  const apiGroupId = decodeURI(getUrlParam("apiGroupId"));
  const apiId = decodeURI(getUrlParam("apiId"));
  const apiName = decodeURI(getUrlParam("apiName"));
  const apiGroupName = decodeURI(getUrlParam("apiGroupName"));

  const [cmsApiGroups, setCmsApiGroups] = useState([]);
  const [currentMenu, setCurrentMenu] = useState(parseInt(apiGroupId, 10) || 0);
  const [currentApi, seturrentApi] = useState(parseInt(apiId, 10) || 0);
  const [josApiId, setJosApiId] = useState(null);
  const [apiDetail, setApiDetail] = useState(null);
  const [apiPage, setApiPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [apiAuthList, setApiAuthList] = useState([]);
  const [userState, setUserState] = useState(0);
  const [apiObj, setApiObj] = useState<any>({});
  /**
   *
   * 判断用户状态
   *
   */
  const getUserState = (curApiId, curApiName) => {
    fetch(`${_host}/docFeedback/userState?apiId=${curApiId}&apiName=${curApiName}&docType=2`, {
      credentials: "include",
    })
      .then((response) => response.json())
      .then((response) => {
        const { code, data } = response;
        if (code === 100000) {
          setUserState(data);
        }
      })
      .catch((err) => console.log(err));
  };

  /**
   *
   * 跳转登录页
   *
   */
  const jumpLoginUrl = () => {
    window.location.href = `${_loginHost}?ReturnUrl=` + encodeURIComponent(window.location.href);
  };

  /**
   *
   * 添加用户评分与反馈
   *
   */
  const addDocFeedBack = (values) => {
    const formParam = new FormData();

    Object.keys(values).forEach((key) => {
      const item = values[key];
      if (item) {
        if (Object.prototype.toString.call(item) === "[object Array]") {
          for (let i = 0; i < item.length; i++) formParam.append(`${key}[${i}]`, item[i]);
        } else {
          formParam.append(key, item);
        }
      }
    });
    const docType: any = 2;
    formParam.append("apiId", apiObj.apiId);
    formParam.append("apiName", apiObj.apiName);
    formParam.append("docType", docType);
    fetch(`${_host}/docFeedback/addDocumentFeedback`, {
      method: "POST",
      body: formParam,
      credentials: "include",
    })
      .then((response) => response.json())
      .then((response) => {
        const { code } = response;
        if (code === 100000) {
          message.success({
            content: "提交成功",
            duration: 3,
            onClose: () => {
              window.location.reload();
            },
            style: {
              marginTop: "50vh",
            },
          });
        } else if (code === 99999) {
          jumpLoginUrl();
          return;
        } else if (code === 600) {
          message.error({
            content: "网络异常，请重新提交",
            duration: 3,
            style: {
              marginTop: "50vh",
            },
          });
        }
      })
      .catch((err) => console.log(err));
  };

  // 后台拉取数据
  const fetchApiGroupData = async () => {
    const group = await fetch(`${_host}/api/index`, {
      credentials: "include",
    }).then((o) => o.json());

    if (group && group.code === 100000) {
      if (!apiId && group.data.length) setCurrentMenu(group.data[0].id);

      setCmsApiGroups(group.data);
    }
  };

  const fetchApiAuthList = (id) => {
    if (id) {
      fetch(`${_host}/api/listOwnedAuthPackage?josApiId=${id}&page=${apiPage}`)
        .then((o) => o.json())
        .then((response) => {
          const { code, data, extData } = response;
          if (code === 100000) {
            setApiAuthList(apiAuthList.concat(data));
            const ex = extData ? parseInt(extData) : 0;
            setTotalPage(ex);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  // 获取接口详情数据
  const fetchApiDetail = (curApiId, curApiName) => {
    setApiObj({
      apiId: curApiId,
      apiName: curApiName,
    });
    fetch(`${_host}/api/detail?id=${curApiId}&apiName=${curApiName}`)
      .then((o) => o.json())
      .then((response) => {
        const { code, data } = response;
        if (code === 100000) {
          setApiDetail(data);
          if (data.josCmsApi && data.josCmsApi.josApiId) {
            setJosApiId(data.josCmsApi.josApiId);
            fetchApiAuthList(data.josCmsApi.josApiId);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchApiAuthList(josApiId);
  }, [apiPage]);

  // 权限包列表
  useEffect(() => {
    if (apiGroupName) {
      setCmsApiGroups([{ id: parseInt(apiGroupId, 10), groupName: apiGroupName }]);
    } else {
      fetchApiGroupData();
    }
    if (apiId && apiName) {
      fetchApiDetail(apiId, apiName);
      getUserState(apiId, apiName);
    }
  }, []);

  return (
    <section className={`${style.app}`}>
      <aside className={style.left_content}>
        <header className={style.title}>
          <img className={style.t_img} src={tagIcon} alt="" />
          API文档
        </header>
        <section className={style.menu_list}>
          {cmsApiGroups &&
            cmsApiGroups.map((o) => {
              return (
                <DropMenu
                  key={o.id}
                  apiGroupName={apiGroupName}
                  currentMenu={currentMenu}
                  currentApi={currentApi}
                  seturrentApi={seturrentApi}
                  item={o}
                  catchApiDetail={(curApiId, curApiName) => {
                    if (curApiId && curApiName) {
                      fetchApiDetail(curApiId, curApiName);
                      getUserState(curApiId, curApiName);
                    }
                  }}
                  josApiId={josApiId}
                  apiPage={apiPage}
                  setJosApiId={setJosApiId}
                />
              );
            })}
        </section>
      </aside>
      <section className={style.right_content}>
        {apiDetail ? (
          <MainDetailContent
            apiDetail={apiDetail}
            apiAuthList={apiAuthList}
            setApiPage={setApiPage}
            totalPage={totalPage}
            apiPage={apiPage}
            userState={userState}
            proposalList={proposalList}
            moreProposalPlaceholder={moreProposalPlaceholder}
            addDocFeedBack={addDocFeedBack}
            jumpLoginUrl={jumpLoginUrl}
          />
        ) : null}
      </section>
    </section>
  );
};

export default App;

// api组 组件
const DropMenu = (props) => {
  const { item, currentMenu, currentApi, seturrentApi, apiGroupName, catchApiDetail } = props;

  const [apiList, setApiList] = useState([]);
  const [isOpen, setIsOpen] = useState(currentMenu === item.id);
  const [hasInit, setHasInit] = useState(false);

  const fetchApiList = async (id) => {
    const { code, data } = apiGroupName
      ? await fetch(`${_host}/api/perm/pack/list?id=${id}`).then((o) => o.json())
      : await fetch(`${_host}/api/list?id=${id}`).then((o) => o.json());
    if (code === 100000) {
      return data.cmsApis || [];
    }
    return [];
  };

  // 查看详情
  const handelApiDetail = (o) => {
    if (o.id !== currentApi) {
      let urlParams = `apiGroupId=${item.id}&apiId=${o.id}&apiName=${o.apiName}`;
      if (apiGroupName) urlParams = urlParams + `&apiGroupName=${apiGroupName}`;
      jumpLink(urlParams);
    }
  };

  // 初始化，判断 当前api组是否选中，如果选择，获取 apiList，如果当前没有选中 api，则默认选择第一个api
  useEffect(() => {
    if (item.id === currentMenu) {
      fetchApiList(currentMenu)
        .then((data) => {
          setHasInit(true);
          setApiList(data);

          let apiId = currentApi;
          if (!apiId && data.length) {
            apiId = data[0].id;
            if (apiId) {
              seturrentApi(apiId);
              const api = data.find((o) => o.id === apiId);
              if (api) {
                // 通过接口动态获取数据
                catchApiDetail(api.id, api.apiName);
              }
            }
          }
        })
        .then((err) => console.log(err));
    }
  }, []);

  // 展开 api 列表
  const handleOpen = async () => {
    setIsOpen(!isOpen);
    if (!hasInit) {
      const apis = await fetchApiList(item.id);
      setHasInit(true);
      setApiList(apis);
    }
  };

  return (
    <section className={style.api_menu_content}>
      <div onClick={handleOpen} className={style.api_menu}>
        {item && item.groupName}

        <span>
          {isOpen ? (
            <img src={upIcon} width={12} height={22} alt="" />
          ) : (
            <img src={downIcon} width={12} height={22} alt="" />
          )}
        </span>
      </div>

      {isOpen ? (
        <div className={style.api_content}>
          {apiList.map((o) => {
            return (
              <div
                key={o.id}
                onClick={() => {
                  handelApiDetail(o);
                }}
                className={cs(style.api_item, o.id === currentApi ? style.active_api_item : "")}
              >
                <div className={style.showName_1}>{o.apiName}</div>
                <div className={style.showName_2}>{o.apiDesc}</div>
              </div>
            );
          })}
        </div>
      ) : null}
    </section>
  );
};

// 内容列表
const MainDetailContent = (props: any) => {
  const { apiDetail, apiAuthList, apiPage, totalPage, setApiPage } = props;

  const {
    josCmsApi,
    josCmsApiGroup,
    method,
    jsonExample,
    xmlExample,
    jsonErrorExample,
    xmlErrorExample,
    apiErrors,
    chargeInfo,
  } = apiDetail;
  let josApiDocQA = JSON.parse(apiDetail.josApiDocQA).data

  return (
    <main className={style.main_content}>
      <header className={style.header_title}>
        <Breadcrumb>
          <Breadcrumb.Item>API文档</Breadcrumb.Item>
          {josCmsApiGroup ? <Breadcrumb.Item>{josCmsApiGroup.groupName}</Breadcrumb.Item> : null}
          <Breadcrumb.Item>{josCmsApi.apiName}</Breadcrumb.Item>
        </Breadcrumb>
      </header>

      <div className={style.title_content}>
        <div className={style.title + " " + style.word_break}>
          {josCmsApi.apiName}
          <span className={style.color_gray}>
            （<span className={style.color_gray} dangerouslySetInnerHTML={{ __html: josCmsApi.znName }}></span>）
          </span>
        </div>
        <div className={style.title_desc}>接口描述：{josCmsApi.apiDesc}</div>
      </div>
      <div className={style.api_desc}>
        {chargeInfo ? <span className={style.charge} title={chargeInfo}>收费 <img className={style.question_img} src={iconQuestion} /></span>:'免费'}
        <span className={style.split_tag}>|</span>
        {method.auth && method.auth === "true" ? "必须用户授权" : "无需用户授权"}
        <span className={style.split_tag}>|</span>
        版本 {josCmsApi.version}
        {josCmsApi.apiLevel && (josCmsApi.apiLevel === "R2" || josCmsApi.apiLevel === "R3") ? (<Space size={0} ><span className={style.split_tag}>|</span>云鼎内调用</Space>) : ""}
      </div>

      {/* 公共参数 */}
      <CommonRequest auth={method.auth && method.auth === "true"} />
      {/* 请求参数 */}
      <RequestParams dataList={method.elements} josCmsApi={josCmsApi} />
      {/* 响应参数 */}
      <ResponseParams dataList={method.josResult.elements} />
      {/* 请求示例 */}
      <RequestExample apiId={josCmsApi.id} />
      {/* 响应示例 */}
      <ResponseExample jsonExample={jsonExample} xmlExample={xmlExample} />
      {/* 异常示例 */}
      <ErrorExample jsonErrorExample={jsonErrorExample} xmlErrorExample={xmlErrorExample} />
      {/* 错误代码示例 */}
      <ApiErrorExample apiErrors={apiErrors} />
      {/* 常见QA */}
      <ApiQasExample josQas={josApiDocQA} />
      {/* API工具*/}
      <ApiTool josCmsApi={josCmsApi} />
      <ApiAuthPackage
        list={apiAuthList}
        apiPage={apiPage}
        totalPage={totalPage}
        setApiPage={setApiPage}
      ></ApiAuthPackage>
      <DocScoreContent {...props}></DocScoreContent>
    </main>
  );
};

// 公共参数
const CommonRequest = (props) => {
  const { auth } = props;
  const columns = [
    {
      title: "名称",
      dataIndex: "name",
      width: 80,
    },
    {
      title: "类型",
      dataIndex: "type",
      width: 50,
    },
    {
      title: "必须",
      dataIndex: "beRequire",
      width: 50,
    },
    {
      title: "描述",
      dataIndex: "desc",
      width: 200,
    },
  ];
  const data = [
    {
      id: 1,
      name: "method",
      type: "String",
      beRequire: "是",
      desc: "API接口描述",
    },
    {
      id: 2,
      name: "access_token",
      type: "String",
      beRequire: auth ? "是" : "否",
      desc: auth ? "采用OAuth授权方式为必填参数" : "非授权接口此参数非必填",
    },
    {
      id: 3,
      name: "app_key",
      type: "String",
      beRequire: "是",
      desc: "应用的app_key",
    },
    {
      id: 4,
      name: "sign",
      type: "String",
      beRequire: "是",
      desc: "签名",
    },
    {
      id: 5,
      name: "timestamp",
      type: "String",
      beRequire: "是",
      desc: "时间戳，格式为yyyy-MM-dd HH:mm:ss，例如：2011-06-16 13:23:30。京东API服务端允许客户端请求时间误差为10分钟",
    },
    {
      id: 6,
      name: "format",
      type: "String",
      beRequire: "否",
      desc: " \t暂时只支持json",
    },
    {
      id: 7,
      name: "v",
      type: "String",
      beRequire: "否",
      desc: "版本：2.0",
    },
  ];

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          公共参数
        </div>
        <div className={style.title_2}>公共请求参数</div>
      </div>

      <Table
        columns={columns}
        rowKey={"id"}
        rowClassName={style.table_row_class}
        pagination={false}
        dataSource={data}
      />
    </section>
  );
};

// 请求参数
const RequestParams = (props) => {
  const { dataList, josCmsApi } = props;

  let resultParams = [];
  // 只有一级，取最底层的 elements
  const filterParam = (params) => {
    params.forEach((item) => {
      if (item.defaultValue || item.SystemValue || item.webPamer.indexOf("$") !== -1) {
        console.log(1);
      } else {
        if (item.elements && item.elements.length > 0) filterParam(item.elements);
        else resultParams.push(item);
      }
    });
  };
  // 多级，需要合并
  const filterParamMuti = (params) => {
    const items = params.filter((item) => {
      if (item.defaultValue || item.SystemValue || item.webPamer.indexOf("$") !== -1) return false;
      return true;
    });

    items.forEach((o, i) => {
      const { elements } = o;
      o.tId = i + 1;
      if (elements && elements.length > 0) {
        const _list = filterParamMuti(elements);
        if (_list.length > 0) o.children = _list;
      }
    });

    return items;
  };

  if (josCmsApi.apiMulti === 1) {
    filterParam(dataList || []);
  }

  if (josCmsApi.apiMulti === 2) {
    resultParams = filterParamMuti(dataList || []);
  }

  // if (!resultParams.length) return null;
  const columns = [
    {
      title: "名称",
      dataIndex: "webPamer",
      width: 178,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div className={style.word_break}>{text}</div>;
      },
    },
    {
      title: "类型",
      dataIndex: "type",
      width: 116,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div className={style.word_break}>{text}</div>;
      },
    },
    {
      title: "必须",
      dataIndex: "required",
      width: 111,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return text ? "是" : "否";
      },
    },
    {
      title: "示例值",
      dataIndex: "value",
      width: 165,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div className={style.word_break}>{text}</div>;
      },
    },

    {
      title: "描述",
      dataIndex: "desc",
      width: 280,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div className={style.word_break}>{text}</div>;
      },
    },
  ];

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          请求参数
        </div>
      </div>

      {/*<Table columns={columns}*/}
      {/*       rowKey={'paramName'}*/}
      {/*       rowClassName={style.table_row_class} pagination={false}*/}
      {/*       // dataSource={dataList.filter(item => {*/}
      {/*       //*/}
      {/*       //   return !item.defaultValue && !item.SystemValue && item.webPamer.indexOf('$') === -1*/}
      {/*       // })}*/}
      {/*  dataSource={resultParams}*/}
      {/*/>*/}

      <Table
        columns={columns}
        rowKey={"paramName"}
        rowClassName={style.table_row_class}
        pagination={false}
        dataSource={resultParams}
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="此接口无入参" /> }}
      />
    </section>
  );
};

const makeData = (data = []) => {
  {
    data.forEach((o) => {
      const { elements } = o;
      if (elements && elements.length > 0) {
        const _list = makeData(elements);
        if (_list.length > 0) o.children = _list;
      }
    });

    return data;
  }
};
// 响应参数
const ResponseParams = (props) => {
  const { dataList } = props;
  if (!dataList.length) return null;
  const columns = [
    {
      title: "名称",
      dataIndex: "webPamer",
      displayName: "webPamer",
      // width: 290,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div style={{ width: 246 }}>{text}</div>;
      },
    },
    {
      title: "类型",
      dataIndex: "type",
      displayName: "type",
      // width: 290,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div style={{ width: 116 }}>{text}</div>;
      },
    },
    {
      title: "示例值",
      dataIndex: "value",
      // width: 100,
      displayName: "value",
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div style={{ width: 80 }}>{text}</div>;
      },
    },
    {
      title: "描述",
      dataIndex: "desc",
      displayName: "desc",
      // width: 180,
      // eslint-disable-next-line react/display-name
      render: (text) => {
        return <div style={{ width: 280 }}>{text}</div>;
      },
    },
  ];

  const resultData = makeData(dataList);
  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          响应参数
        </div>
      </div>

      <Table
        columns={columns}
        rowKey={"webPamer"}
        rowClassName={style.table_row_class}
        pagination={false}
        dataSource={resultData}
      />
    </section>
  );
};

// 请求实例
const RequestExample = (props) => {
  const { apiId } = props;
  const [dataInfo, setDataInfo] = useState(null);
  useEffect(() => {
    fetch(`${_host}/api/sdkExampleTemplate?id=${apiId}`)
      .then((o) => o.json())
      .then((response) => {
        const { code, data } = response;
        if (code === 100000) setDataInfo(data);
      })
      .catch((err) => console.log(err));
  }, []);

  const menus = [
    { id: 1, name: "JAVA", tag: "sdkJavaExampleTemplate" },
    { id: 2, name: "PHP", tag: "sdkPhpExampleTemplate" },
    { id: 3, name: ".NET", tag: "sdkNetExampleTemplate" },
    { id: 4, name: "Python", tag: "sdkPythonExampleTemplate" },
  ];

  if (!dataInfo) return null;

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          请求示例
        </div>
      </div>

      <Tabs defaultActiveKey="" type={"card"}>
        {menus.map((o) => {
          return (
            <Tabs.TabPane tab={o.name} key={o.id}>
              <div className={style.tab_content}>
                <div dangerouslySetInnerHTML={{ __html: dataInfo[o.tag] }} />
              </div>
            </Tabs.TabPane>
          );
        })}
      </Tabs>
    </section>
  );
};

// 响应示例
const ResponseExample = (props) => {
  const { jsonExample, xmlExample } = props;

  const menus = [
    { id: 1, name: "JSON", content: jsonExample },
    { id: 2, name: "XML", content: xmlExample },
  ];

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          响应示例
        </div>
      </div>

      <Tabs defaultActiveKey="" type={"card"}>
        {menus.map((o) => {
          return (
            <Tabs.TabPane tab={o.name} key={o.id}>
              <div className={style.tab_content}>
                <pre>{o.content}</pre>
              </div>
            </Tabs.TabPane>
          );
        })}
      </Tabs>
    </section>
  );
};

// 异常示例
const ErrorExample = (props) => {
  const { jsonErrorExample, xmlErrorExample } = props;

  const menus = [
    { id: 1, name: "JSON", content: jsonErrorExample },
    { id: 2, name: "XML", content: xmlErrorExample },
  ];

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          异常示例
        </div>
      </div>

      <Tabs defaultActiveKey="" type={"card"}>
        {menus.map((o) => {
          return (
            <Tabs.TabPane tab={o.name} key={o.id}>
              <div className={style.tab_content}>
                <pre>{o.content}</pre>
              </div>
            </Tabs.TabPane>
          );
        })}
      </Tabs>
    </section>
  );
};

// 错误代码示例
const ApiErrorExample = (props) => {
  const { apiErrors } = props;

  const columns = [
    {
      title: "错误码",
      width: 100,
      dataIndex: "code",
    },
    {
      title: "错误消息",
      width: 200,
      dataIndex: "error",
    },
    {
      title: "解决方案",
      width: 100,
      dataIndex: "solution",
    },
  ];

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          错误代码示例
        </div>
      </div>

      <Table
        columns={columns}
        rowKey={"tId"}
        rowClassName={style.table_row_class}
        pagination={false}
        dataSource={apiErrors.map((o, i) => ({ ...o, tId: i + 1 }))}
      />
    </section>
  );
};

// 常见QA
const ApiQasExample = (props) => {
  const { josQas } = props;

  const columns = [
    {
      title: "问题",
      width: 100,
      dataIndex: "question",
    },
    {
      title: "解决方案",
      width: 200,
      dataIndex: "answer",
    },
  ];

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          常见QA
        </div>
      </div>

      <Table
        columns={columns}
        rowKey={"tId"}
        rowClassName={style.table_row_class}
        pagination={false}
        dataSource={josQas.map((o, i) => ({ ...o, tId: i + 1 }))}
      />
    </section>
  );
};

// API 工具
const ApiTool = (props) => {
  const { josCmsApi } = props;

  // 跳转 api test
  const handleToApiTest = () => {
    const { origin } = window.location;
    window.open(`${origin}/apitest?id=${josCmsApi.id}&apiName=${josCmsApi.apiName}`, "_blank");
  };

  // 跳转 api 工具
  const handleToApiTools = (id) => {
    const { origin } = window.location;
    window.open(`${origin}/commontools?id=${id}`, "_blank");
  };

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          API工具
        </div>
      </div>

      <div>
        <span className={style.api_test_btn} onClick={handleToApiTest}>
          API测试工具
        </span>
        <span className={style.api_test_btn} onClick={() => handleToApiTools(1)}>
          授权工具
        </span>
        <span className={style.api_test_btn} onClick={() => handleToApiTools(2)}>
          签名工具
        </span>
        <span className={style.api_test_btn} onClick={() => handleToApiTools(3)}>
          权限查询
        </span>
      </div>
    </section>
  );
};

// API 工具

const ApiAuthPackage = (props) => {
  const { list, apiPage, totalPage, setApiPage } = props;
  const column = [
    {
      title: "拥有此API的权限包",
      dataIndex: "authPackageName",
      key: "authPackageName",
      // eslint-disable-next-line react/display-name
      render: (text, record) => {
        return (
          <a href={`/apilist?apiGroupId=${record.authPackageId}&apiGroupName=${record.authPackageName}`}>{text}</a>
        );
      },
    },
    {
      title: "可获得/可申请该API权限包的应用类型",
      dataIndex: "appTypeNames",
      key: "appTypeNames",
    },
  ];

  return (
    <section className={style.card_class}>
      <div className={style.header_title}>
        <div className={style.title_1}>
          <div className={style.tag}></div>
          如何获取该API
        </div>
      </div>
      {totalPage > 0 ? (
        <a
          href="https://jos-console.jd.com/#/app/index"
          target="_blank"
          className={style.jumpLink}
          rel="noopener noreferrer"
        >
          前往控制台创建应用
        </a>
      ) : null}

      <div className={style.api_auth_package_wrap}>
        <Table
          columns={column}
          rowKey={"authPackageId"}
          rowClassName={style.table_row_class}
          pagination={false}
          dataSource={list}
        />
        {apiPage > 0 && apiPage < totalPage ? (
          <a
            className={style.search_more}
            onClick={() => {
              setApiPage(apiPage + 1);
            }}
          >
            查看更多
          </a>
        ) : null}
      </div>
    </section>
  );
};

// 评分模块
const DocScoreContent = (props: any) => {
  const { userState, proposalList = [], moreProposalPlaceholder, addDocFeedBack, jumpLoginUrl } = props;
  const [form] = Form.useForm();

  /**
   *
   * 添加用户评分与反馈
   *
   */
  const submitForm = (values) => {
    addDocFeedBack(values);
  };

  return (
    <div className={style.doc_score_wrap}>
      {userState === 0 ? (
        <div>
          请
          <a
            onClick={() => {
              jumpLoginUrl();
            }}
          >
            登录
          </a>
          后评价！
        </div>
      ) : null}
      {userState === 1 ? (
        <div className={style.set_score_wrap}>
          <Form form={form} layout="vertical" onFinish={submitForm}>
            <FormItem
              name="docSatisfaction"
              label="对此文档的满意度评分是："
              rules={[
                { required: true, message: "请进行评价" },
                {
                  pattern: new RegExp(/^[1-5]{1}$/, "g"),
                  message: "请进行评价",
                },
              ]}
            >
              <Rate className={style.rate_wrap}></Rate>
            </FormItem>
            <FormItem
              name="proposal"
              label="为了让我们更好的优化文档和改善服务，我们希望您能提出宝贵建议："
              rules={[{ required: true, message: "请勾选建议项" }]}
            >
              <CheckboxGroup className={style.proposal_wrap}>
                {proposalList &&
                  proposalList.map((item) => {
                    return (
                      <Checkbox key={item.value} value={item.value}>
                        {item.value}
                      </Checkbox>
                    );
                  })}
              </CheckboxGroup>
            </FormItem>
            <FormItem
              name="moreProposal"
              label={<span style={{ paddingLeft: "12px" }}>更多建议：</span>}
              rules={[{ required: false, message: "Please select your country!" }]}
            >
              <TextArea
                className={style.more_proposal_wrap}
                rows={4}
                showCount
                maxLength={500}
                placeholder={moreProposalPlaceholder}
              ></TextArea>
            </FormItem>
            <FormItem>
              <div className={style.submit_btn_wrap}>
                <Button type="primary" htmlType="submit">
                  提交
                </Button>
              </div>
            </FormItem>
          </Form>
        </div>
      ) : null}
      {userState === 2 ? (
        <div>
          <span className="color-blue">温馨提示：</span> 您当日评价次数已达上限，感谢您的建议！
        </div>
      ) : null}
    </div>
  );
};
